import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/catch'
import { UserService } from './user.service';
import { CacheService } from './cache.service';
import { UserDetail } from '../../models/userDetail';

@Injectable()
export class CachedUserService {
  private _userDetail: BehaviorSubject<UserDetail> = new BehaviorSubject<UserDetail>(null);
  public readonly userDetail: Observable<UserDetail> = this._userDetail.asObservable();

  constructor(private userService: UserService, private cacheService: CacheService) { }

  getUserDetails(): Observable<UserDetail> {
    return this.cacheService.get("user_details", this.userService.getUserDetails().map(d => {
      this._userDetail.next(d);
      return d;
    }));
  }

  getBillingGroupAdmin(groupName: string): Observable<any> {
    return this.cacheService.get("billing_group_" + groupName, this.userService.getBillingGroupAdmin(groupName));
  }

  isGroupAdmin(): Observable<boolean> {
    return this.getUserDetails().switchMap((detail) => {
      if (!detail || !detail.groupName)
        return Observable.of(false);

      return this.getBillingGroupAdmin(detail.groupName).map(groupAdmin => {
        return detail.id == groupAdmin;
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/cached-user.service.ts